<script setup>
import { Icon, Checkbox, Button } from '@components';
import { computed, ref } from 'vue';
import moment from 'moment';

const props = defineProps({
    day: {
        type: String,
        required: true
    }
});

const emit = defineEmits(['apply']);

const selectedDays = ref([]);

const selectDays = (day) => {
    if (selectedDays.value.includes(day)) {
        selectedDays.value = selectedDays.value.filter(d => d !== day);
    } else {
        selectedDays.value.push(day);
    }
};

const weekDays = computed(() => {
    return moment.weekdays().map(day => ({
        label: day,
        value: day
    }));
});

const cloneSlot = () => {
    if(selectedDays.value.length == 0) return
    emit('apply', props.day, selectedDays.value);
    selectedDays.value = [];
};
</script>

<template>
<div
    class="absolute bottom-0 h-max p-2 z-50 bg-white border border-[#dadcdf] rounded-lg top-10 right-0">
    <div class="flex flex-col gap-2">
        <Checkbox v-for="day in weekDays" :key="day.value" :value="day.value"
            :checked="selectedDays.includes(day.value)" @click.prevent="selectDays(day.value)">
            <div class="text-[#374153] text-sm font-medium">{{ day.label }}</div>
        </Checkbox>
        <Button size="sm" classButton="!py-1" @click="cloneSlot">Apply</Button>
    </div>
</div>
</template>